import { NgModule } from "@angular/core";

import { SearchModule } from "@box/components";
import { VaultFilterServiceAbstraction, VaultFilterService } from "@box/vault";
import { OrganizationWarningsModule } from "@box/web-vault/app/billing/organizations/warnings/organization-warnings.module";

import { VaultFilterSharedModule } from "../../individual-vault/vault-filter/shared/vault-filter-shared.module";

import { OrganizationOptionsComponent } from "./components/organization-options.component";
import { VaultFilterComponent } from "./components/vault-filter.component";

@NgModule({
  imports: [VaultFilterSharedModule, SearchModule, OrganizationWarningsModule],
  declarations: [VaultFilterComponent, OrganizationOptionsComponent],
  exports: [VaultFilterComponent],
  providers: [
    {
      provide: VaultFilterServiceAbstraction,
      useClass: VaultFilterService,
    },
  ],
})
export class VaultFilterModule {}
